import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/UsersTable.vue"),
          meta: { title: "Список пользователей", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/UsersForm.vue"),
          meta: { title: "Создать пользователя", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/UsersForm.vue"),
          meta: { title: "Редактировать пользователя", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id/regions/append/",
          component: () => import("@/views/forms/UserRegionAppendForm.vue"),
          meta: {
            title: "Задать регионы пользователя",
            activeMenuParent: true,
          },
          hidden: true,
        },
        {
          path: "edit/:id/regions/remove/",
          component: () => import("@/views/forms/UserRegionRemoveForm.vue"),
          meta: {
            title: "Удалить регионы пользователя",
            activeMenuParent: true,
          },
          hidden: true,
        },
        {
          path: "vrio/:id/list",
          component: () => import("@/views/table/UsersVrioTable.vue"),
          name: "UsersVrioTable",
          meta: {
            title: "Список заместителей пользователя",
            activeMenuParent: true,
          },
          hidden: true,
        },
        {
          path: "vrio/:id/create",
          component: () => import("@/views/forms/UsersVrioForm.vue"),
          meta: {
            title: "Добавить заместителя пользователя",
            activeMenuParent: true,
          },
          hidden: true,
        },
        {
          path: "vrio/:id/edit/:vrioId",
          component: () => import("@/views/forms/UsersVrioForm.vue"),
          meta: {
            title: "Редактировать заместителя пользователя",
            activeMenuParent: true,
          },
          hidden: true,
        },
      ],
    },
  ];
};
